import { render, staticRenderFns } from "./rewardDetail.vue?vue&type=template&id=38c27012&scoped=true"
import script from "./rewardDetail.vue?vue&type=script&lang=js"
export * from "./rewardDetail.vue?vue&type=script&lang=js"
import style0 from "./rewardDetail.vue?vue&type=style&index=0&id=38c27012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c27012",
  null
  
)

export default component.exports